/**
 * The cohort selector shared by Live Sessions, Review Queue and
 * Leadership (requirement 3). Controlled: `value` is the picked
 * cohortId or null for "All cohorts". Non-archived cohorts, PLUS an
 * archived one that still has a live pairing (#191: "archive, let them
 * finish" leaves the pairing Active so its run keeps going — dropping it
 * from the filter would make that run unfilterable). Fully archived
 * rosters' history still shows under "All".
 */
import type { CohortEntityRow } from '@/hooks/useCohortEntities';

export function CohortFilterSelect({
  cohorts,
  value,
  onChange,
}: {
  cohorts: CohortEntityRow[];
  value: bigint | null;
  onChange: (cohortId: bigint | null) => void;
}) {
  const active = cohorts.filter(
    (c) => !c.archived || c.pairings.some((p) => p.storedStatus === 'Active'),
  );
  if (active.length === 0) return null;
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 11,
        color: 'var(--muted)',
      }}
      title="Show only assignments created (or adopted) by this cohort's orientation pairings."
    >
      Cohort
      <select
        className="inp"
        style={{ fontSize: 12, padding: '2px 6px', maxWidth: 200 }}
        value={value == null ? '' : String(value)}
        onChange={(e) =>
          onChange(e.target.value === '' ? null : BigInt(e.target.value))
        }
        aria-label="Filter by cohort"
      >
        <option value="">(all)</option>
        {active.map((c) => (
          <option key={String(c.cohortId)} value={String(c.cohortId)}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  );
}
